import * as templates from './templates';

const createExistPetBtns = (existPets, existPetBody) => {
    var existPetItems = '';

    existPetBody.find('.js-acitve-btn').remove();

    $.each(existPets, function (i, item) {
        let IsCareClubMember = false;
        let gender = '0';
        if(item.SexId){
            gender = item.SexId;
        }
        if(item.CareClubPlan == null){
            IsCareClubMember = true
        }
        existPetItems += `${templates.existPet({ displayName: item.Name, imgURL:item.PetPhoto, petId:item.Id, careClub:item.IsPatientCareClubMember, species:item.SpeciesName, isMember:IsCareClubMember, genderId:gender })}`;
    });
    existPetBody.prepend(existPetItems);
}

const createPetTypeBtns = (petTypes, petTypetBody, othersListy) => {
    var catTypesItems = '';
    var dogTypesItems = '';
    var otherPetTypesItems = '';

    $.each(petTypes, function (i, item) {
        if (item.SpeciesId == 1) {
            dogTypesItems += `${templates.petType({ displayName:item.DisplayName, imgURL:item.IconBaseUrl, imgURL2:item.IconHoverUrl, speciesId:item.SpeciesId, name:item.Name })}`;
        }
        else if (item.SpeciesId == 2) {
            catTypesItems += `${templates.petType({ displayName:item.DisplayName, imgURL:item.IconBaseUrl, imgURL2:item.IconHoverUrl, speciesId:item.SpeciesId, name:item.Name })}`;
        }
         else {
            otherPetTypesItems += `${templates.otherPetType({ displayName:item.DisplayName, speciesId:item.Id, name:item.Name })}`;
            $('.js-vca-dropdown-button').show();
        }
    });
    petTypetBody.prepend(catTypesItems);
    petTypetBody.prepend(dogTypesItems);
  //  othersListy.append(otherPetTypesItems);
}

const populatedBreedsList = (breedsList, selectBreedEl, species) => {
    let breedsListObj = '<option value="" selected="selected">Breed*</option>';
    $.each(breedsList, function (i, item) {
        if(item.SpeciesId == species){
            breedsListObj += `${templates.breedsOptions({ displayName:item.Name,Id:item.Id, speciesId:item.SpeciesId })}`;
        }
    });
    selectBreedEl.html(breedsListObj);
}


const createVerifyInputs = (petName, verifyBody) => {
    var petInputs = '';

    $.each(petName, function (i, item) {
        petInputs  +=  `${templates.petInputGroup({ displayName:item })}`;
    });
    verifyBody.html(petInputs);
}

const createServiceBtn = (services, serviceList, servicesDesc) => {
    var servicesAry = '';
    var serviceDescAry = '';

    $.each(services, function (i, item) {
        servicesAry += `${templates.serviceBtn({ displayName:item.ServiceName, imgURL:item.Icon, serviceId:item.ServiceId, ind:i })}`;
        serviceDescAry += `${templates.serviceDesc({  displayName:item.ServiceName, desc:item.Description, ind:i })}`;
    });
    serviceList.html(servicesAry);
    servicesDesc.html(serviceDescAry);
  //  othersListy.append(otherPetTypesItems);
}


const createHospitalList = (hospitals, hospitalDesc) => {
    var hospitalsAry = '';

    $.each(hospitals, function (i, item) {
        hospitalsAry += `${templates.hospitalItem({ name:item.DisplayName, id:item.HospitalId, index:i })}`;
    });
    hospitalDesc.html(hospitalsAry);
}

export {
    createExistPetBtns,
    createPetTypeBtns,
    createVerifyInputs,
    populatedBreedsList,
    createServiceBtn,
    createHospitalList
  }